import { gql } from '@apollo/client';

export interface LessonDraft {
    id: string;
    lessonName: string;
    dateUpdated: string;
    published: boolean;
}

export interface GetLessonVariables {
    where: {
        id: string;
    };
}

export interface GetLessonResponse {
    lesson: {
        id: string;
        latestLessonVersion: {
            lessonName: string;
        };
        latestLessonDraft: LessonDraft;
        shareWithPublic: boolean;
        sharesCount: number;
        shares: {
            id: string;
            user: {
                name: string;
                email: string;
            };
            email: string;
        }[];
        teacher: {
            id: string;
            user: {
                name: string;
                email: string;
            };
        };
        folder?: {
            id: string;
            sharesCount: number;
        };
    };
}

export const GET_LESSON = gql`
    query Lesson($where: LessonWhereUniqueInput!) {
        lesson(where: $where) {
            id
            latestLessonVersion {
                lessonName
            }
            latestLessonDraft {
                id
                lessonName
                dateUpdated
                published
            }
            shareWithPublic
            sharesCount
            shares {
                id
                user {
                    name
                    email
                }
                email
            }
            teacher {
                id
                user {
                    name
                    email
                }
            }
        }
    }
`;

export interface CreateLessonSharesVariables {
    data: {
        email: string;
        lesson: {
            connect: { id: string };
        };
        user: {
            connect: { email: string };
        };
    }[];
}

export interface CreateLessonSharesResponse {
    createLessonShares: {
        id: string;
        email: string;
    }[];
}

export const CREATE_LESSON_SHARES = gql`
    mutation CreateLessonShares($data: [LessonShareCreateInput!]!) {
        createLessonShares(data: $data) {
            id
            email
        }
    }
`;

export interface DeleteLessonShareVariables {
    where: {
        id: string;
    }[];
}

export interface DeleteLessonShareResponse {
    deleteLessonShares: {
        id: string;
        email: string;
    }[];
}

export const DELETE_LESSON_SHARES = gql`
    mutation DeleteLessonShares($where: [LessonShareWhereUniqueInput!]!) {
        deleteLessonShares(where: $where) {
            id
            email
        }
    }
`;
